import React from 'react'

import OutroLayout from '../layouts/Outro.jsx'

const Outro = (props) => {
  return (
    <OutroLayout
      title={props?.data?.section_1?.title ?? ''}
      name={props?.data?.section_1?.name ?? ''}
      email={props?.data?.section_1?.email ?? ''}
    />
  )
}

export default Outro
